/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductListImage,
    AdminProductListImageFromJSON,
    AdminProductListImageFromJSONTyped,
    AdminProductListImageToJSON,
} from './AdminProductListImage';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminGroupSaleListProduct
 */
export interface AdminGroupSaleListProduct {
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    asin?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    categoryId: string;
    /**
     * 
     * @type {ProductConsistency}
     * @memberof AdminGroupSaleListProduct
     */
    consistency: ProductConsistency;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminGroupSaleListProduct
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    groupSaleID?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    id: string;
    /**
     * 
     * @type {Array<AdminProductListImage>}
     * @memberof AdminGroupSaleListProduct
     */
    images?: Array<AdminProductListImage>;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleListProduct
     */
    listingNumber: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleListProduct
     */
    lowestResalePrice: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleListProduct
     */
    msrp: number;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleListProduct
     */
    palletOrderID?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleListProduct
     */
    purchasePrice: number;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminGroupSaleListProduct
     */
    status: AdminProductStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleListProduct
     */
    updatedAt?: string;
}



export function AdminGroupSaleListProductFromJSON(json: any): AdminGroupSaleListProduct {
    return AdminGroupSaleListProductFromJSONTyped(json, false);
}

export function AdminGroupSaleListProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleListProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'categoryId': json['category_id'],
        'consistency': ProductConsistencyFromJSON(json['consistency']),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : json['deletedAt'],
        'groupSaleID': !exists(json, 'groupSaleID') ? undefined : json['groupSaleID'],
        'id': json['id'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(AdminProductListImageFromJSON)),
        'listingNumber': json['listingNumber'],
        'lowestResalePrice': json['lowestResalePrice'],
        'msrp': json['msrp'],
        'name': json['name'],
        'palletOrderID': !exists(json, 'palletOrderID') ? undefined : json['palletOrderID'],
        'purchasePrice': json['purchasePrice'],
        'status': AdminProductStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function AdminGroupSaleListProductToJSON(value?: AdminGroupSaleListProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'category_id': value.categoryId,
        'consistency': ProductConsistencyToJSON(value.consistency),
        'consistencyDetails': value.consistencyDetails,
        'createdAt': value.createdAt,
        'deletedAt': value.deletedAt,
        'groupSaleID': value.groupSaleID,
        'id': value.id,
        'images': !value.images ? undefined : ((value.images as Array<any>).map(AdminProductListImageToJSON)),
        'listingNumber': value.listingNumber,
        'lowestResalePrice': value.lowestResalePrice,
        'msrp': value.msrp,
        'name': value.name,
        'palletOrderID': value.palletOrderID,
        'purchasePrice': value.purchasePrice,
        'status': AdminProductStatusToJSON(value.status),
        'updatedAt': value.updatedAt,
    };
}

